<template>
    <div class="sustainable-component wage-positions">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-new-test</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-5">Befattning</th>
                                <th class="col-5">Riktarbete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in jobPositions" :key="index">
                                <td>
                                    <span v-if="selected != item">{{item.Name}}</span>
                                </td>
                                <td class="p-0">
                                    <span v-if="selected != item">
                                        <v-checkbox v-bind:disabled="disabled" density="compact" v-model="item.ReferencePosition" hide-details></v-checkbox>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="saveReferencePositions">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>
    import { getCurrentInstance } from 'vue'
    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {
        emits: ['updated'],
        name: 'wage-positions',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async load() {
                this.loading++;
                try {
                    this.jobPositions = await WageService.getReferencePositions();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async saveReferencePositions() {
                this.loading++;
                try {
                    await WageService.saveReferencePositions(this.jobPositions);
                    this.displaySnackBar("Sparat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                jobPositions: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.load();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
